import React from 'react';
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';

const propTypes = {
  children: PropTypes.array.isRequired,
};

const OuterWrap = ({ children }) => (
  <S.OuterWrap>{React.Children.map(children, (child, i) => child)}</S.OuterWrap>
);

OuterWrap.propTypes = propTypes;

export default OuterWrap;
